import { createContext } from "react"

const ReceiptOfInvoiceContext = createContext()

export default ReceiptOfInvoiceContext
